import { Image, TextButton, TOPBAR_HEIGHT } from '@capsicum/common-web';
import { HeaderWarning } from '@capsicum/features/regulations/web';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.large};

	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		margin-bottom: ${({ theme }) => theme.sizing.xxlarge};
	}
`;

export const ProductUkHeaderWarning = styled(HeaderWarning)`
	background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
	top: ${TOPBAR_HEIGHT}px;
`;

export const Title = styled.span`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
	margin: ${({ theme }) => theme.spacings.xxlarge} 0 ${({ theme }) => theme.spacings.large};
`;

export const MainContainer = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacings.small};
	padding: ${({ theme }) => theme.spacings.small};
	background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	${({ theme }) => theme.border.radius.medium};

	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		flex-direction: column;
	}
`;

export const StyledTextButton = styled(TextButton)`
	flex-shrink: 0;
`;

export const BuyTokensLabel = styled.div`
	display: flex;
	${({ theme }) => theme.border.radius.circle};
	box-sizing: border-box;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	padding: ${({ theme }) => `${theme.spacings.xxxsmall} ${theme.spacings.xsmall}`};
	border: 1px solid ${({ theme }) => theme.colors.borders.main.divider};
	margin-right: auto;
`;

export const TokensNeededText = styled.div`
	${({ theme }) => theme.fonts.text.text4};
	color: ${({ theme }) => theme.colors.text.main.enabled};
	padding-left: ${({ theme }) => theme.spacings.xxsmall};
	padding-right: ${({ theme }) => theme.spacings.xxxsmall};
	flex: 1;
	border: 0;
	word-break: break-all;
`;

export const Divider = styled.div`
	margin-top: ${({ theme }) => theme.spacings.small};
	border-top: 1px solid ${({ theme }) => theme.colors.borders.main.divider};
`;

export const InformationWrapper = styled.div`
	margin-top: ${({ theme }) => theme.spacings.small};
	margin-bottom: ${({ theme }) => theme.spacings.small};
`;

export const ImageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	display: flex;
	flex: 1 0 0;
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		margin-bottom: ${({ theme }) => theme.spacings.medium};
	}
`;

export const GalleryView = styled.div`
	display: flex;
	width: 100%;
	overflow: hidden;
	margin-top: ${({ theme }) => theme.spacings.medium};
	&:hover {
		overflow-x: scroll;
	}
	${({ theme }) =>
		theme.breakpoints.queries.builder.or(
			theme.breakpoints.queries.above.tabletSmallDesktop,
			theme.breakpoints.queries.only.mobile
		)} {
		&:hover {
			overflow-x: unset;
		}
	}
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		margin-bottom: ${({ theme }) => theme.spacings.medium};
		margin-top: 0;
	}
`;

export const StyledCardImagePlaceholder = styled.div`
	height: 254px;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.skeleton.default};
`;

export const StyledImage = styled(Image)`
	object-fit: contain;
`;

export const Pressable = styled.div<{ $selected: boolean }>`
	margin-right: ${({ theme }) => theme.spacings.xxsmall};
	border: ${({ $selected, theme }) =>
		$selected
			? `${theme.border.width.large} solid ${theme.colors.borders.brand.selected}`
			: `${theme.border.width.large} solid ${theme.colors.backgrounds.transparent}`};
`;

export const ProductImage = styled(Image)`
	object-fit: contain;
	width: 100%;
	margin: 0 auto;
	${({ theme }) =>
		theme.breakpoints.queries.builder.or(
			theme.breakpoints.queries.above.mediumDesktop,
			theme.breakpoints.queries.only.mobile
		)} {
	}
`;

export const ImageContainer = styled.div`
	width: 100%;
	max-width: 100%;
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		margin-bottom: ${({ theme }) => theme.spacings.medium};
	}
`;

export const Content = styled.div`
	display: flex;
	flex: 1 0 0;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.small};
`;

export const HeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	gap: ${({ theme }) => theme.spacings.xxsmall};
`;

export const Link = styled.a`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
	${({ theme }) => theme.fonts.text.text3};
	text-decoration: none;
`;

export const BlockTitle = styled.div<{ $isMarginBottom?: boolean }>`
	margin-bottom: ${({ $isMarginBottom, theme }) => ($isMarginBottom ? theme.spacings.small : 0)};
	${({ theme }) => theme.fonts.text.text1}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Description = styled.div`
	${({ theme }) => theme.fonts.text.text3}
	color:${({ theme }) => theme.colors.text.main.enabled};
	white-space: pre-line;
`;

export const TitleWrapper = styled.div`
	flex: 1;
	align-items: center;
`;

export const Category = styled.div`
	${({ theme }) => theme.fonts.text.caption1};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const CategoryTitle = styled.div`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
	margin: ${({ theme }) => theme.spacings.xxlarge} 0 0;
	${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
		margin-left: ${({ theme }) => theme.spacings.small};
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	align-self: flex-end;
	align-items: center;

	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		position: fixed;
		display: grid;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 10;
		padding: ${({ theme }) => `${theme.spacings.xsmall} ${theme.spacings.small}`};
		background: ${({ theme }) => theme.colors.backgrounds.main.translucent};
		border-top: ${({ theme }) => `1px solid ${theme.colors.borders.main.divider}`};
		backdrop-filter: blur(2px);
	}
`;

export const CategoryInfo = styled.div`
	display: flex;
`;

export const InfoWrapper = styled.div`
	margin-right: ${({ theme }) => theme.spacings.medium};
`;

export const DetailsTitle = styled.div`
	${({ theme }) => theme.fonts.text.text1}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const DetailsValue = styled.div`
	${({ theme }) => theme.fonts.text.text3}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;
